import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, FieldArray} from 'redux-form';
import {Card, Grid, Button, Form} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {parseOriginWarehousesAllowed} from '../../../common/util/options';
import {Actions} from '../../../common/actions';
import {TRANSFER_FORM} from '../../../common/forms';
import {DropdownField} from '../../../common/components/form';
import ExcelReader from '../../../excelReader/components/index';
import TransferDetail from './detail';
import './transfers.scss';

class TransferFrom extends Component {
  constructor(props) {
    super(props);

    this.loadFile = this.loadFile.bind(this);
    this.renderExcelImport = this.renderExcelImport.bind(this);
    this.createTransfer = this.createTransfer.bind(this);
    this.rejectTransfer = this.rejectTransfer.bind(this);
  }

  componentDidMount() {
    this.props.fetchWarehouses();
  }

  componentWillUnmount() {
    const {code} = this.props;
    if (code) {
      this.props.rejectTransfer(code);
    }
  }

  formatWarehouses(list, excludedWarehouse) {
    const originWarehousesAllowed = [];
    list.forEach((element) => {
      if (
        true || hasAccessPermission(
          this.props.permissions,
          `Bodega ${element.code}`,
          'Transferir Stock'
        )
      ) {
        originWarehousesAllowed.push(element);
      }
    });

    const parsedList = parseOriginWarehousesAllowed(originWarehousesAllowed);

    if (excludedWarehouse) {
      return parsedList.filter((item) => item.value !== excludedWarehouse);
    }

    return parsedList;
  }

  createTransfer() {
    const {origin, destination} = this.props;

    this.props.createNewTransfer({origin, destination});
  }

  loadFile(data) {
    const {origin, destination} = this.props;
    const detail = this.formatTransferDetail(data);
    this.props.processStockTransfer({origin, destination, detail}, false);
  }

  rejectTransfer() {
    const {code} = this.props;
    this.props.rejectTransfer(code);
  }

  formatTransferDetail(data) {
    return data.map((item) => ({'partCode': item[0], 'quantity': item[1]}));
  }

  renderExcelImport(code, origin, destination) {
    if (origin && destination && !code) {
      return <ExcelReader onGetFile={this.loadFile} text='IMPORTAR' />;
    }

    return null;
  }

  renderMainButton(code) {
    const {processingTransfer} = this.props;

    if (!code) {
      return (
        <Button
          fluid
          primary
          onClick={this.createTransfer}
          loading={processingTransfer}
          type='button'
        >
          CREAR
        </Button>
      );
    }

    return (
      <Button fluid primary type='submit'>
        ENVIAR
      </Button>
    );
  }

  renderDetail({fields}) {
    return <TransferDetail fields={fields} />;
  }

  render() {
    const {
      code,
      origin,
      destination,
      warehouses,
      handleSubmit,
      submitting,
      processingTransfer,
    } = this.props;

    return (
      <Form
        onSubmit={handleSubmit}
        loading={submitting || processingTransfer}
        className='manual-transfers-form'
      >
        <Card className='form-header' raised fluid>
          <Grid>
            <Grid.Row>
              <Grid.Column width={13} textAlign='left'>
                <h2>Transferencia entre Bodegas:</h2>
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                {this.renderExcelImport(code, origin, destination)}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2} verticalAlign='middle'>
                <h4>
                  <strong>Bodega de origen:</strong>
                </h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='origin'
                  component={DropdownField}
                  options={this.formatWarehouses(warehouses)}
                  disabled={!!code}
                  fluid
                  required
                />
              </Grid.Column>
              <Grid.Column width={2} verticalAlign='middle'>
                <h4>
                  <strong>Bodega de destino:</strong>
                </h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='destination'
                  component={DropdownField}
                  options={this.formatWarehouses(warehouses, origin)}
                  disabled={!!code}
                  fluid
                  required
                />
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                {this.renderMainButton(code)}
              </Grid.Column>
              <Grid.Column width={3} textAlign='right'>
                {code && (
                  <Button
                    fluid
                    primary
                    onClick={this.rejectTransfer}
                    type='button'
                  >
                    CANCELAR
                  </Button>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        {code && (
          <Card fluid>
            <FieldArray name='detail' component={this.renderDetail} />
          </Card>
        )}
      </Form>
    );
  }
}

export {TransferFrom};

const form = reduxForm({
  'form': TRANSFER_FORM.name,
})(TransferFrom);

const mapStateToProps = (state) => {
  const {values, loading} = state.form.transfer;
  const {origin, destination, code} = values || {};
  return {
    'loadingFile': state.excelReader.loading,
    'warehouses': state.warehouses.list,
    'processingTransfer': loading,
    'code': code,
    'origin': origin,
    'destination': destination,
    'permissions': state.session.permissions,
  };
};

const {
  fetchWarehouses,
  createNewTransfer,
  processStockTransfer,
  removeTransferItem,
  rejectTransfer,
} = Actions;

export default connect(mapStateToProps, {
  fetchWarehouses,
  createNewTransfer,
  processStockTransfer,
  removeTransferItem,
  rejectTransfer,
})(form);
